import React from "react";
import "./OnlineDatabase.scss";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";

const OnlineDatabase = () => {
  return (
    <>
    <SectionTitle2 title="ONLINE DATABASE" />

    <section className="online-database">
      <div className="container">
        {/* <h1 className="page-title">ONLINE DATABASE</h1> */}

        <div className="card">
          <h2 className="tagline">
            CDJ Law Journal Online
          </h2>
          <p className="quote">
            “Where academia meets practice, and ideas shape the future of law.”
          </p>

          <p className="description">
            CDJ Law Journal Online is a comprehensive digital legal research
            platform that enables faculty members and students to engage with
            contemporary legal issues. It advances the discourse on law and
            justice while empowering legal minds to contribute towards building
            a just society.
          </p>

          <div className="highlight">
            Enjoy the atmosphere of a <strong>dust-free</strong> and
            <strong> paper-less</strong> office.
          </div>

          <ul className="features">
            <li>Exhaustive coverage of all law subjects</li>
            <li>Full-text judgments with headnotes and comparative citations</li>
            <li>Powerful search engine for quick legal research</li>
            <li>Judgment database from <strong>1868 to present</strong></li>
            <li>More judgments than any other law journal</li>
            <li>Space and cost-efficient digital access</li>
            <li>Ideal for academic, research, and professional use</li>
          </ul>
        </div>
      </div>
    </section>
    </>
  );
};

export default OnlineDatabase;
